import { ClientCompanyBranchData } from '@/common/types/client/companyBranch.type'
import { CardDetailsData } from '@/features/cards/types/CardDetails.type'
import type { CompanyData } from '@/features/companies/types/companies.type'
import { cardDetailsComponents } from '@/features/consumption/constants/cardDetails.constant'
import React from 'react'

interface EquipmentInfoProps {
  cardDetails: CardDetailsData
  companyData: CompanyData
  clientBranch?: ClientCompanyBranchData
}

export const EquipmentInfo = ({ cardDetails, companyData, clientBranch }: EquipmentInfoProps) => {
  return React.createElement(cardDetailsComponents[cardDetails?.type as keyof typeof cardDetailsComponents], {
    cardDetails,
    companyData,
    clientBranch,
  })
}
